import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { USTimePipe } from './us-time.pipe';
import { USTimelinePipe } from './us-timeline.pipe';
import { DateIsoPipe } from './date-iso.pipe';
import { DatePrettyPipe } from './date-pretty.pipe';
import { TimelineCountPipe } from './timeline-count.pipe';
import { ConferenceOwnerPipe } from './conference-owner.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations:   [
    USTimePipe,
    USTimelinePipe,
    DateIsoPipe,
    DatePrettyPipe,
    TimelineCountPipe,
    ConferenceOwnerPipe
  ],
  exports:        [
    USTimePipe,
    USTimelinePipe,
    DateIsoPipe,
    DatePrettyPipe,
    TimelineCountPipe,
    ConferenceOwnerPipe
  ],
})
export class PipesModule {
  static forRoot() {
    return {
        ngModule: PipesModule,
        providers: [],
    };
 }
}




// WEBPACK FOOTER //
// ./src/app/core/pipes/pipes.module.ts